export default __webpack_public_path__ + "static/media/step2-icon.35eb151d.svg";